import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-store-buttons',
  templateUrl: './store-buttons.component.html',
  styleUrls: ['./store-buttons.component.scss']
})
export class StoreButtonsComponent implements OnInit {
  @Input() googlePlayStore: string
  @Input() appleAppStore: string

  constructor() { }

  ngOnInit(): void { }
}
